module.exports = __webpack_public_path__ + "img/delivery-img.9564e2e7.png";